import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import './styles.scss';
import { useHistory } from 'react-router-dom';
import { setPet, setPetAction } from '../../redux/petData';

import SubProductCard from '../../components/SubProductCard';
import WizardLayout from '../../components/WizardLayout';
import WizardNavigation from '../../components/WizardNavigation';
import useWizardSteps from '../../hooks/useWizardSteps';

import { FormControl, InputLabel, Input } from '@material-ui/core';

export default function PetType() {
  const { insuranceProducts, insuranceSelected } = useSelector(
    ({ insurances }) => ({
      insuranceSelected: insurances.selected,
      insuranceProducts:
        insurances.selected && insurances.selected.insuranceCompany.products
    })
  );

  const history = useHistory();

  const [name, setName] = useState();
  const [type, setType] = useState();
  const [active, setActive] = useState();
  const [error, setError] = useState();
  const dispatch = useDispatch();

  const productsLocalInfo = insuranceSelected.subProducts;

  const products = [
    {
      product: {
        productId: 1,
        longDesc: 'Gato'
      },
      productInfo: {
        img: require('./../../img/gato.svg')
      }
    },
    {
      product: {
        productId: 2,
        longDesc: 'Perro'
      },
      productInfo: {
        img: require('./../../img/perro.svg')
      }
    }
  ];

  const handleChange = (e) => {
    setError('');
    const name = e.target.value;
    setName(name);
  };

  const handleClick = (e, id, type) => {
    setType(type);
    setActive(id);
  };

  const [activeStep] = useWizardSteps(2);

  function handleNextStep() {
    if (type && name) {
      dispatch(setPet({ type, name }));
      history.push('/domicilio');
    } else {
      setError('Campo obligatorio');
    }
  }

  return (
    <WizardLayout
      activeStep={activeStep}
      withNavigation={false}
      showNextButton={false}
    >
      <Grid
        container
        item
        xs={12}
        lg={10}
        spacing={2}
        justify='center'
        style={{ marginTop: 24 }}
      >
        <span className='pet-title'>
          <strong>Contanos</strong> que mascota tenés y cómo se llama
        </span>
        <div className='container-rounded'>
          <div className='circle-pencil'>
            <img
              src={require('../../img/pencil.svg')}
              alt=''
              style={{ width: '50%' }}
            />
          </div>
          <div className='container-types'>
            {products.map((item) => {
              return (
                <div
                  key={item.product.productId}
                  onClick={(e) =>
                    handleClick(
                      e,
                      item.product.productId,
                      item.product.longDesc
                    )
                  }
                >
                  <SubProductCard
                    active={active == item.product.productId}
                    retrieveInfo={true}
                    product={item.product}
                    productLocalInfo={item.productInfo}
                  />
                </div>
              );
            })}
          </div>
          <div className='name-container'>
            <FormControl fullWidth={true}>
              <InputLabel shrink focused={false} htmlFor='name'>
                Nombre
              </InputLabel>
              <Input id='name' name='name' onChange={handleChange} />
              <span className='error'>{error && error}</span>
            </FormControl>
          </div>
        </div>
      </Grid>
      <WizardNavigation nextAction={handleNextStep} />
    </WizardLayout>
  );
}
